import { arrayMoveImmutable } from 'array-move'

export const reorderById = <T extends { id: string }>(
  rows: readonly T[],
  activeId: string,
  overId: string,
): readonly T[] => {
  const oldIndex = rows.findIndex((r) => r.id === activeId)
  const newIndex = rows.findIndex((r) => r.id === overId)
  if (oldIndex === -1 || newIndex === -1 || activeId === overId) {
    return rows
  }
  return arrayMoveImmutable(rows, oldIndex, newIndex)
}
